module.exports = __webpack_public_path__ + "img/shrewd-save-1.c42d99d8.jpg";